import React from "react";
import AreaMap from "~/components/AreaMap";

const OverlapPlots = ({ gleba, results, glebaLayers }) => {
  const sobreposicao = results.B3ConsultaCriterioArea.find(
    (criterio) =>
      criterio.B3Criterio.slug === 'sobreposicao_outras_glebas' &&
      criterio.b3_area_id === gleba.B3AreasB3PropostaGleba[0]?.B3Area?.id
  );

  const overlayGeoms = sobreposicao?.detalhes_json?.detalhes?.filter(
    (detalhe) => !!detalhe.geom
  ) ?? [];

  return (
    <AreaMap
      aoiInfo={gleba.B3AreasB3PropostaGleba[0]}
      layers={glebaLayers}
      overlayGeoms={overlayGeoms}
      showLegend={true}
      className="area-map"
    />
  );
};

export default OverlapPlots;